import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesFeatureAuth = {
  description: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageFeatureAuthInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesFeatureAuth}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageFeatureAuthInitializer.displayName = 'Page Feature Auth initializer component';

export default PageFeatureAuthInitializer;
